import { PresetSearchParamsCustomDefaultValues } from "@impero-com/ui/domain";

export const CLASSIFICATION_LIST_TABLE_STATE_STORAGE_KEY = "classificationList";

export const CLASSIFICATION_LIST_COLUMN_IDS = {
    NAME: "name",
    DESCRIPTION: "description",
    ACTION: "action",
} as const;

export const classificationListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [{ id: CLASSIFICATION_LIST_COLUMN_IDS.NAME, desc: false }],
    };
